import { includes } from '@edicom/common/string/includes';
fbScriptDirective.$inject = ['$compile'];

export default function fbScriptDirective($compile) {
  return {
    restrict: 'E',
    template: `<div ec-layout=""></div>`,
    scope: {
      variables: '=',
      insert: '=',
    },
    link,
  };

  function link(scope, element) {
    const elem = element[0];
    const eDiv = elem.querySelector('div[ec-layout]');
    scope.search = '';

    render();

    scope.$watch('search', renderButtonsGroup, true);

    function render() {
      eDiv.innerHTML = `
      <main style="width=auto; heigth: auto;">
        <ec-input ng-model="search" icon="filter"></ec-input>
        <ec-group style="flex-direction: column; padding: 6px;">
        ${scope.variables
          .map(variable => {
            return `<ec-button label="@${variable}" click="insert('@${variable}')"></ec-button>`;
          })
          .join('')}
        </ec-group>
      </main>`;

      $compile(eDiv)(scope);
    }

    function renderButtonsGroup() {
      const eButtonsGroup = elem.querySelector('ec-group');
      eButtonsGroup.innerHTML = `
        ${scope.variables
          .filter(variable => includes(addAtSymbol(variable), scope.search))
          .map(variable => {
            return `<ec-button label="${addAtSymbol(variable)}" click="insert('${addAtSymbol(variable)}')"></ec-button>`;
          })
          .join('')}
      `;
      $compile(eButtonsGroup)(scope);
    }

    function addAtSymbol(value) {
      return `@${value}`;
    }
  }
}
